<template>
    <PageContainer>
        <PageHeader>
            {{ $t('stockCharge.show.page_title') }}
        </PageHeader>

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="fs-5">{{ $t('stockCharge.user') }}</div>
                    <preview-item :title="$t('user.name')" :description="log.user.name" />
                    <preview-item :title="$t('user.email')" :description="log.user.email" />
                    <preview-item :title="$t('user.role')" :description="log.user.role" />
                </div>
                <div class="col-md-4">
                    <div class="fs-5">{{ $t('stockCharge.product') }}</div>
                    <preview-item :title="$t('product.name')" :description="log.product.name" />
                    <preview-item :title="$t('product.size_type')" :description="log.product.size_type" />
                </div>
                <div class="col-md-4">
                    <div class="fs-5">{{ $t('stockCharge.size') }}</div>
                    <preview-item :title="$t('product.size')" :description="log.product_size.size.toString()" />
                    <preview-item :title="$t('product.quantity')" :description="log.quantity_added.toString()" />
                </div>
            </div>
        </div>

        <div>
            <BackButton href="/stockCharge" />
        </div>
    </PageContainer>
</template>

<script setup lang="ts">
import type {StockChargeLogInterface} from "@/components/helpers/Interfaces.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import PreviewItem from "@/components/elements/PreviewItem.vue";
import BackButton from "@/components/buttons/BackButton.vue";

const { log } = defineProps<{
    log: StockChargeLogInterface
}>()
</script>

<style scoped>

</style>
